(function () {
  var cartIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true" focusable="false"><rect x="7" y="8" width="10" height="12" rx="2" /><path d="M9 8a3 3 0 0 1 6 0v1" stroke="currentColor" stroke-width="0.9" fill="none" /></svg>';
  var checkIcon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1F6E2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6L9 17l-5-5"/></svg>';

  function formatVariantPrice(cents) {
    var currency = typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'EUR';

    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: currency
    });
  }

  function showCheckmark(button) {
    if (!button) {
      return;
    }

    button.innerHTML = checkIcon;
    button.classList.add('added');

    window.setTimeout(function () {
      button.innerHTML = cartIcon;
      button.classList.remove('added');
    }, 2000);
  }

  function updateCartCount() {
    return fetch(getCartUrl(), {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart konnte nicht geladen werden.');
        }
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-count, [data-header-cart-count]').forEach(function (element) {
          element.textContent = cart.item_count > 0 ? cart.item_count : '0';
        });
      });
  }

  function getRoute(name, fallback) {
    if (typeof KROWN !== 'undefined' && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes[name]) {
      return KROWN.settings.routes[name];
    }

    return fallback;
  }

  function getCartAddUrl() {
    return getRoute('cart_add_url', '/cart/add') + '.js';
  }

  function getCartUrl() {
    return getRoute('cart_url', '/cart') + '.js';
  }

  function getProductUrl(handle) {
    var root = typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    var separator = root.slice(-1) === '/' ? '' : '/';

    return root + separator + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function handleFetchError(response, fallbackMessage) {
    return response.text().then(function (text) {
      var message = fallbackMessage;

      if (text) {
        try {
          var parsed = JSON.parse(text);
          message = parsed.description || parsed.message || text;
        } catch (error) {
          message = text;
        }
      }

      throw new Error(message);
    });
  }

  function addVariantToCart(variantId) {
    return fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    }).then(function (response) {
      if (!response.ok) {
        return handleFetchError(response, 'Produkt konnte nicht hinzugefuegt werden.');
      }
      return response.json();
    });
  }

  function getSliderElements(section) {
    var slider = section.querySelector('.s-product-slider__css-slider');
    var holder = slider ? slider.querySelector('.css-slider-holder') : null;
    var prevButton = slider ? slider.querySelector('.css-slider-prev') : null;
    var nextButton = slider ? slider.querySelector('.css-slider-next') : null;

    return {
      holder: holder,
      prevButton: prevButton,
      nextButton: nextButton
    };
  }

  function getCardStep(holder) {
    var items = holder ? holder.querySelectorAll('.product-item') : [];

    if (!holder || !items.length) {
      return 0;
    }

    if (items.length > 1) {
      return Math.abs(items[1].offsetLeft - items[0].offsetLeft);
    }

    var styles = window.getComputedStyle(holder.querySelector('.grid') || holder);
    var gap = parseFloat(styles.columnGap || styles.gap || 0);

    return items[0].getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
  }

  function updateSliderButtons(section) {
    var elements = getSliderElements(section);
    var holder = elements.holder;

    if (!holder || !elements.prevButton || !elements.nextButton) {
      return;
    }

    var tolerance = 2;
    var maxScroll = holder.scrollWidth - holder.clientWidth;
    var atStart = holder.scrollLeft <= tolerance;
    var atEnd = holder.scrollLeft >= maxScroll - tolerance;

    elements.prevButton.classList.toggle('disabled', atStart);
    elements.nextButton.classList.toggle('disabled', atEnd || maxScroll <= tolerance);
  }

  function initSingleStepSlider(section) {
    var slider = section.querySelector('.s-product-slider__css-slider');

    if (!slider || slider.dataset.sProductSliderSingleStep === 'true') {
      return;
    }

    slider.dataset.sProductSliderSingleStep = 'true';

    section.addEventListener('click', function (event) {
      var button = event.target.closest('.css-slider-prev, .css-slider-next');

      if (!button || !slider.contains(button)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (button.classList.contains('disabled')) {
        return;
      }

      var elements = getSliderElements(section);
      var holder = elements.holder;
      var step = getCardStep(holder);

      if (!holder || !step) {
        return;
      }

      var direction = button.classList.contains('css-slider-next') ? 1 : -1;
      var maxScroll = holder.scrollWidth - holder.clientWidth;
      var nextScroll = Math.max(0, Math.min(maxScroll, holder.scrollLeft + step * direction));

      holder.scrollTo({
        top: 0,
        left: nextScroll,
        behavior: 'smooth'
      });

      window.setTimeout(function () {
        updateSliderButtons(section);
      }, 350);
    }, true);

    var queued = false;

    function requestButtonUpdate() {
      if (queued) {
        return;
      }

      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        updateSliderButtons(section);
      });
    }

    function bindHolder() {
      var elements = getSliderElements(section);

      if (!elements.holder || elements.holder.dataset.sProductSliderScrollBound === 'true') {
        updateSliderButtons(section);
        return;
      }

      elements.holder.dataset.sProductSliderScrollBound = 'true';
      elements.holder.addEventListener('scroll', requestButtonUpdate, { passive: true });
      updateSliderButtons(section);
    }

    slider.addEventListener('ready', bindHolder);
    slider.addEventListener('reset', bindHolder);
    slider.addEventListener('change', requestButtonUpdate);
    window.addEventListener('resize', requestButtonUpdate);

    bindHolder();
  }

  function initSection(section) {
    if (!section || section.dataset.sProductSliderInitialized === 'true') {
      return;
    }

    section.dataset.sProductSliderInitialized = 'true';

    var modal = section.querySelector('[data-s-product-slider-modal]');
    var modalClose = section.querySelector('[data-s-product-slider-modal-close]');
    var variantSelect = section.querySelector('[data-s-product-slider-variant-select]');
    var modalAdd = section.querySelector('[data-s-product-slider-modal-add]');
    var lastClickedButton = null;

    initSingleStepSlider(section);

    function closeModal() {
      if (modal) {
        modal.hidden = true;
      }
    }

    function openVariantModal(product, button) {
      if (!modal || !variantSelect) {
        return;
      }

      lastClickedButton = button;
      variantSelect.innerHTML = '';

      product.variants.forEach(function (variant) {
        if (!variant.available) {
          return;
        }

        var option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title + ' - ' + formatVariantPrice(variant.price);
        variantSelect.appendChild(option);
      });

      modal.hidden = false;
      variantSelect.focus();
    }

    section.addEventListener('click', function (event) {
      var button = event.target.closest('.product-grid-add-to-cart-button');

      if (!button || !section.contains(button)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (button.disabled) {
        return;
      }

      var variantCount = parseInt(button.getAttribute('data-variant-count'), 10);
      var variantId = button.getAttribute('data-product-id');
      var productHandle = button.getAttribute('data-product-handle');

      lastClickedButton = button;
      button.disabled = true;

      if (variantCount > 1) {
        fetch(getProductUrl(productHandle), {
          credentials: 'same-origin'
        })
          .then(function (response) {
            if (!response.ok) {
              return handleFetchError(response, 'Produktdaten konnten nicht geladen werden.');
            }
            return response.json();
          })
          .then(function (product) {
            openVariantModal(product, button);
          })
          .catch(function (error) {
            console.error('S-Product-Slider:', error);
          })
          .finally(function () {
            button.disabled = false;
          });

        return;
      }

      addVariantToCart(variantId)
        .then(function () {
          showCheckmark(button);
          return updateCartCount();
        })
        .catch(function (error) {
          console.error('S-Product-Slider:', error);
        })
        .finally(function () {
          button.disabled = false;
        });
    });

    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) {
          closeModal();
        }
      });
    }

    if (modalAdd) {
      modalAdd.addEventListener('click', function () {
        var variantId = variantSelect ? variantSelect.value : '';

        if (!variantId) {
          return;
        }

        modalAdd.disabled = true;

        addVariantToCart(variantId)
          .then(function () {
            closeModal();
            showCheckmark(lastClickedButton);
            return updateCartCount();
          })
          .catch(function (error) {
            console.error('S-Product-Slider:', error);
          })
          .finally(function () {
            modalAdd.disabled = false;
          });
      });
    }
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-s-product-slider]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
